import type { DynamicNavItemGroup, ProcessedNavItemGroup } from '@/lib/routing/routing.types'

/**
 * Hook that processes dynamic navigation groups by fetching their data
 * and transforming it into NavItem arrays.
 *
 * @param groups - Array of dynamic navigation groups to process
 * @returns Array of processed navigation groups with loaded navItems
 */
export function useDynamicNavigationGroups(groups: DynamicNavItemGroup[]): ProcessedNavItemGroup[] {
  return groups.map((group) => ({
    ...group,
    navItems: [],
  }))
}
